import { useState, useEffect } from 'outpost/preact';
import { BoardLocalData } from '../board/board-local-data.ts';
import { ClientConnection } from '../board/client-connection.ts';
import { loadProjectFromCache, saveProjectToCache } from '../cache.ts';
import { generateCardImages } from '../card-drawing.ts';
import { HASH_STOARGE_KEY, GAME_ID_PARAM_NAME } from '../constants.ts';
import { fetchGoogleSpreadsheet } from '../google-docs-api.ts';
import { Project } from '../project.ts';
import { parseSpreadsheet } from '../spreadsheet-parsing.ts';
import { App } from './app.tsx';
import { LocalStorage } from '../local-storage.ts';

export type AutoConnectProps = {

};

export function AutoConnect(props: AutoConnectProps) {
    let [guestConnection, setGuestConnection] = useState<ClientConnection | null>(null);

    let connectToGame = async (gameId: string) => {
        let initParams = await App.instance.runAction('Connecting to game', async () => {
            guestConnection = await ClientConnection.start({ label: 'guest' });
            setGuestConnection(guestConnection);
            guestConnection.joinGame(gameId);

            return guestConnection.whenConnectedToGame();
        });

        if (!initParams) {
            setTimeout(() => alert(`Invalid game ID.`));
            return;
        }

        let { spreadsheetId, projectHash, board } = initParams;
        let project: Project | null = null;

        if (LocalStorage.readString(HASH_STOARGE_KEY) === projectHash) {
            project = await App.instance.runAction('Loading cache', () => loadProjectFromCache());
        }

        if (!project) {
            let spreadsheet = await App.instance.runAction('Fetching spreadsheet', () => fetchGoogleSpreadsheet({ id: spreadsheetId }));
            project = await App.instance.runAction('Parsing spreadsheet', () => parseSpreadsheet(spreadsheet));

            await App.instance.runAction('Generating cards', () => generateCardImages(project!, {
                imageLoader: App.instance.assetLoader,
                pdfQuality: false
            }));
            await App.instance.runAction('Saving to cache', () => saveProjectToCache(project));
        }

        return new Promise<BoardLocalData>(resolve => {
            App.instance.setState({
                project,
                showCards: true,
                hasCache: true,
                justSaved: true,
                playPanelOpen: true,
                isGuest: true,
                initBoardCallback: localData => {
                    localData.setConnection(guestConnection!);
                    localData.board = board;
                    resolve(localData);
                }
            });
        });
    };

    useEffect(() => {
        let urlParams = new URLSearchParams(window.location.search);
        let gameId = urlParams.get(GAME_ID_PARAM_NAME);

        if (gameId) {
            connectToGame(gameId);
        }
    }, []);

    return <></>;
};